import type { UseFormPayload } from '@domain-group/react-hooks'

import { Form } from '@domain-group/suit-theme'

import EntitySelector from '@components/EntitySelector'

interface EditOrderBundleItemProps {
  orderBundleItemForm: UseFormPayload,
}

const EditOrderBundleItem = (props: EditOrderBundleItemProps) => {
  const { orderBundleItemForm } = props

  const {
    entityState: {
      price_override,
      product_code,
      product_name,
      provider_id,
      publication_id,
      sort,
      title,
    },
    errors,
    handlers,
    setEntityState,
  } = orderBundleItemForm

  return (
    <Form>
      <EntitySelector
        callbacks={{
          selectItem: publication => setEntityState({ publication_id: publication?.id }),
        }}
        entityKey="publications"
        searchRequestOptions={{ provider_id }}
        selectedItemId={publication_id}
      />

      <Form.Field errorMessage={errors.title} label="* Item" marginTop="large">
        <input name="title" value={title} {...handlers} />
      </Form.Field>

      <Form.Field label="Product Name" marginTop="large">
        <input name="product_name" value={product_name} {...handlers} />
      </Form.Field>

      <Form.Field label="Product Code" marginTop="large">
        <input name="product_code" value={product_code} {...handlers} />
      </Form.Field>

      <Form.Field label="Sort" marginTop="large">
        <input data-value-type="integer" name="sort" value={sort} {...handlers} />
      </Form.Field>

      <Form.Field label="Price" marginTop="large">
        <input name="price_override" type="number" value={price_override} {...handlers} />
      </Form.Field>
    </Form>
  )
}

export default EditOrderBundleItem
